import { Button } from "@nextui-org/react";
import Cookies from "js-cookie";
import React, { useState, useEffect, useCallback } from "react";
import InputMask from "react-input-mask";
import "react-phone-number-input/style.css";

import { Loader } from "../../../../../../components/utils";
import { toast } from "../../../../../../helpers";

// import "./Form.css";

console.log("NODE_ENV:", process.env.NODE_ENV);

const defaultFormDataTeste = Cookies.get("formDataDeclaracaoEndereco")
    ? JSON.parse(Cookies.get("formDataDeclaracaoEndereco"))
    : {
          nome: "",
          email: "",
          cpf: "",
          nacionalidade: "",
          estado_civil: "",
          profissao: "",
          numero_rg: "",
          cep: "",
          logradouro: "",
          numero: "",
          complemento: "",
          bairro: "",
          cidade: "",
          estado: ""
      };

const Form = ({ setData, setError }) => {
    const [formErrors, setFormErrors] = useState({
        nome: "",
        email: "",
        cpf: "",
        nacionalidade: "",
        estado_civil: "",
        profissao: "",
        numero_rg: "",
        cep: "",
        logradouro: "",
        numero: "",
        complemento: "",
        bairro: "",
        cidade: "",
        estado: ""
    });
    const [loading, setLoading] = useState(false);

    //Form
    const [formData, setFormData] = useState(defaultFormDataTeste);

    const validateForm = useCallback(() => {
        const errors = {};
        if (!formData.nome?.trim()) errors.nome = "Campo obrigatório";
        if (!formData.email?.trim()) errors.email = "Campo obrigatório";
        if (!formData.cpf?.trim()) errors.cpf = "Campo obrigatório";
        if (!formData.nacionalidade?.trim()) errors.nacionalidade = "Campo obrigatório";
        if (!formData.estado_civil?.trim()) errors.estado_civil = "Campo obrigatório";
        if (!formData.profissao?.trim()) errors.profissao = "Campo obrigatório";
        if (!formData.numero_rg?.trim()) errors.numero_rg = "Campo obrigatório";
        if (!formData.cep?.trim()) errors.cep = "Campo obrigatório";
        if (!formData.logradouro?.trim()) errors.logradouro = "Campo obrigatório";
        if (!formData.numero?.trim()) errors.numero = "Campo obrigatório";
        if (!formData.bairro?.trim()) errors.bairro = "Campo obrigatório";
        if (!formData.cidade?.trim()) errors.cidade = "Campo obrigatório";
        if (!formData.estado?.trim()) errors.estado = "Campo obrigatório";
        setFormErrors(errors);
    }, [formData]);

    useEffect(() => {
        // Chamada da função de validação
        validateForm();
    }, [validateForm]);

    const handleChange = async e => {
        const name = e.target.name;
        const value = e.target.value;
        // Para todos os outros campos, atualiza o estado normalmente.
        setFormData(prevFormData => ({
            ...prevFormData,
            [name]: value
        }));
    };

    const handleCepChange = async e => {
        const novoCep = e.target.value;
        setFormData({
            ...formData,
            ["cep"]: novoCep
        });

        if (novoCep.length === 8) {
            try {
                const response = await fetch(`https://viacep.com.br/ws/${novoCep}/json/`);
                const data = await response.json();

                if (!data.erro) {
                    setFormData({
                        ...formData,
                        ["logradouro"]: data.logradouro,
                        ["bairro"]: data.bairro,
                        ["cidade"]: data.localidade,
                        ["estado"]: data.uf
                    });
                    document.getElementsByName("numero")[0].focus();
                } else {
                    alert("CEP não encontrado.");
                }
            } catch (error) {
                console.error("Erro ao buscar o CEP:", error);
            }
        }
    };

    const handleSubmit = async e => {
        e.preventDefault();
        const errors = validateForm();
        if (Object.keys(formErrors).length === 0) {
            const userToken = process.env.REACT_APP_API_TOKEN;
            const url = `${process.env.REACT_APP_API_HOST}/formularios/bancobs2/pf/declaracao_endereco`;

            const formDataTemp = {
                nome: formData.nome,
                email: formData.email,
                cpf: formData.cpf,
                nacionalidade: formData.nacionalidade,
                estado_civil: formData.estado_civil,
                profissao: formData.profissao,
                numero_rg: formData.numero_rg,
                cep: formData.cep,
                logradouro: formData.logradouro,
                numero: formData.numero,
                complemento: formData.complemento,
                bairro: formData.bairro,
                cidade: formData.cidade,
                estado: formData.estado
            };

            try {
                const response = await fetch(url, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        authorization: `Bearer ${userToken}`
                    },
                    body: JSON.stringify(formDataTemp),
                    credentials: "include"
                });

                if (response.status === 200) {
                    const jsonData = await response.json();
                    setData(jsonData);

                    Cookies.set("fileExistsDeclaracaoEndereco", JSON.stringify(jsonData), {
                        expires: 7
                    });
                    Cookies.set("formDataDeclaracaoEndereco", JSON.stringify(formDataTemp), {
                        expires: 30
                    });

                    setError(null);
                } else {
                    toast(
                        "error",
                        `Erro ao enviar resposta\n\n${response.status} ${response.statusText}\n\nDúvidas? Entre em contato no WhatsApp +55 11 93211-4516`,
                        true
                    );
                }
            } catch (error) {
                console.error("Erro ao fazer a requisição:", error);
                setError(error.message);
            } finally {
                setLoading(false);
            }
        } else {
            setFormErrors(errors);
            setLoading(false);
            console.log(errors);
            if (errors) {
                toast("error", "Erro ao enviar resposta\nPreencha os campos obrigatórios.");
            } else {
                toast(
                    "error",
                    "Erro ao enviar resposta\nDúvidas? Entre em contato no WhatsApp +55 11 93211-4516",
                    true
                );
            }
        }
    };

    const Required = () => {
        return <span className="text-red-500 font-bold">*</span>;
    };
    return (
        <form
            className="bg-white p-8 rounded-lg shadow-lg w-full md:min-w-[400px] md:max-w-3xl mx-auto"
            autoComplete="off"
        >
            <p className="text-gray-500 mb-8 text-center">
                O Banco BS2 é a instituição financeira parceira da SuzanCâmbio na realização de
                transferências internacionais. Por isso, após o preenchimento desta declaração você
                receberá um e-mail com a declaração do BS2 devidamente preenchida para conferência e
                assinatura digital.
                <br />
                Todos os dados informados neste formulário serão mantidos em total sigilo pela
                SuzanCâmbio e BS2, seguindo rigorosamente as diretrizes da lei de proteção geral de
                dados - LGPD.
            </p>
            <h2 className="text-2xl font-bold mb-6 text-gray-800 text-center">Declaração</h2>
            <div className="mb-4">
                <label htmlFor="nome" className="block text-gray-700">
                    Nome completo <Required />
                </label>
                <input
                    id="nome"
                    name="nome"
                    type="text"
                    value={formData.nome ?? ""}
                    onChange={handleChange}
                    autoComplete="nope"
                    aria-label="nome"
                    className={`mt-2 p-2 w-full border rounded-md ${formErrors?.nome ? "border-red-500" : ""}`}
                />
                {formErrors.nome && <p className="text-red-500 text-xs mt-1">{formErrors.nome}</p>}
            </div>
            <div className="mb-6">
                <label htmlFor="email" className="block text-gray-700">
                    Email: <Required />
                </label>
                <input
                    id="email"
                    name="email"
                    type="text"
                    value={formData.email}
                    onChange={handleChange}
                    autoComplete="nope"
                    placeholder=" "
                    aria-label="email"
                    className={`mt-2 p-2 w-full border rounded-md ${formErrors.email ? "border-red-500" : ""}`}
                />
                {formErrors.email && (
                    <p className="text-red-500 text-xs mt-1">{formErrors.email}</p>
                )}
            </div>
            <div className="mb-6 w-full grid grid-cols-2 space-x-2">
                <div>
                    <label htmlFor="cpf" className="block text-gray-700">
                        CPF <Required />
                    </label>
                    <InputMask
                        mask={"999.999.999-99"}
                        value={formData.cpf}
                        onChange={handleChange}
                        autoComplete="nope"
                        id="cpf"
                        name="cpf"
                        aria-label="cpf"
                        className={`mt-2 p-2 w-full border rounded-md ${formErrors.cpf ? "border-red-500" : ""}`}
                    >
                        {inputProps => <input {...inputProps} type="tel" />}
                    </InputMask>
                    {formErrors.cpf && (
                        <p className="text-red-500 text-xs mt-1">{formErrors.cpf}</p>
                    )}
                </div>
                <div>
                    <label htmlFor="numero_rg" className="block text-gray-700">
                        Número do RG: <Required />
                    </label>
                    <input
                        id="numero_rg"
                        name="numero_rg"
                        type="text"
                        value={formData.numero_rg}
                        onChange={handleChange}
                        autoComplete="nope"
                        placeholder=" "
                        aria-label="numero_rg"
                        className={`mt-2 p-2 w-full border rounded-md ${formErrors.numero_rg ? "border-red-500" : ""}`}
                    />
                    {formErrors.numero_rg && (
                        <p className="text-red-500 text-xs mt-1">{formErrors.numero_rg}</p>
                    )}
                </div>
            </div>
            <div className="mb-6">
                <label htmlFor="nacionalidade" className="block text-gray-700">
                    Nacionalidade: <Required />
                </label>
                <input
                    id="nacionalidade"
                    name="nacionalidade"
                    type="text"
                    value={formData.nacionalidade}
                    onChange={handleChange}
                    autoComplete="nope"
                    placeholder=" "
                    aria-label="nacionalidade"
                    className={`mt-2 p-2 w-full border rounded-md ${formErrors.nacionalidade ? "border-red-500" : ""}`}
                />
                {formErrors.nacionalidade && (
                    <p className="text-red-500 text-xs mt-1">{formErrors.nacionalidade}</p>
                )}
            </div>
            <div className="mb-6">
                <label htmlFor="estado_civil" className="block text-gray-700">
                    Estado Civil: <Required />
                </label>
                <input
                    id="estado_civil"
                    name="estado_civil"
                    type="text"
                    value={formData.estado_civil}
                    onChange={handleChange}
                    autoComplete="nope"
                    placeholder=" "
                    aria-label="estado_civil"
                    className={`mt-2 p-2 w-full border rounded-md ${formErrors.estado_civil ? "border-red-500" : ""}`}
                />
                {formErrors.estado_civil && (
                    <p className="text-red-500 text-xs mt-1">{formErrors.estado_civil}</p>
                )}
            </div>
            <div className="mb-6">
                <label htmlFor="profissao" className="block text-gray-700">
                    Profissão: <Required />
                </label>
                <input
                    id="profissao"
                    name="profissao"
                    type="text"
                    value={formData.profissao}
                    onChange={handleChange}
                    autoComplete="nope"
                    placeholder=" "
                    aria-label="profissao"
                    className={`mt-2 p-2 w-full border rounded-md ${formErrors.profissao ? "border-red-500" : ""}`}
                />
                {formErrors.profissao && (
                    <p className="text-red-500 text-xs mt-1">{formErrors.profissao}</p>
                )}
            </div>
            <hr className="mt-8 mb-8" />
            <div className="mb-4">
                <label htmlFor="cep" className="block text-gray-700">
                    CEP: <Required />
                </label>
                <InputMask
                    mask={"99999999"}
                    maskChar={null}
                    value={formData.cep}
                    onChange={handleCepChange}
                    onBlur={handleCepChange}
                    id="cep"
                    name="cep"
                    className={`mt-2 p-2 w-50% border rounded-md ${formErrors.cep ? "border-red-500" : ""}`}
                >
                    {inputProps => <input {...inputProps} type="tel" />}
                </InputMask>
                {formErrors.cep && <p className="text-red-500 text-xs mt-1">{formErrors.cep}</p>}
            </div>
            <div className="mb-6 space-y-4">
                <div>
                    <label htmlFor="logradouro" className="block text-gray-700">
                        Logradouro residencial: <Required />
                    </label>
                    <input
                        type="text"
                        name="logradouro"
                        value={formData.logradouro}
                        onChange={handleChange}
                        autoComplete="nope"
                        className={`mt-2 p-2 w-full border rounded-md ${formErrors.logradouro ? "border-red-500" : ""}`}
                    />
                    {formErrors.logradouro && (
                        <p className="text-red-500 text-xs mt-1 mb-2">{formErrors.logradouro}</p>
                    )}
                </div>
                <div>
                    <label htmlFor="numero" className="block text-gray-700">
                        Número residencial: <Required />
                    </label>
                    <input
                        type="text"
                        name="numero"
                        value={formData.numero}
                        onChange={handleChange}
                        autoComplete="nope"
                        className={`mt-2 p-2 w-full border rounded-md ${formErrors.numero ? "border-red-500" : ""}`}
                    />
                    {formErrors.numero && (
                        <p className="text-red-500 text-xs mt-1 mb-2">{formErrors.numero}</p>
                    )}
                </div>
                <div>
                    <label htmlFor="complemento" className="block text-gray-700">
                        Complemento residencial:
                    </label>
                    <input
                        type="text"
                        name="complemento"
                        value={formData.complemento}
                        onChange={handleChange}
                        autoComplete="nope"
                        className={`mt-2 p-2 w-full border rounded-md ${formErrors.complemento ? "border-red-500" : ""}`}
                    />
                    {formErrors.complemento && (
                        <p className="text-red-500 text-xs mt-1 mb-2">{formErrors.complemento}</p>
                    )}
                </div>
                <div>
                    <label htmlFor="bairro" className="block text-gray-700">
                        Bairro residencial: <Required />
                    </label>
                    <input
                        type="text"
                        name="bairro"
                        value={formData.bairro}
                        onChange={handleChange}
                        autoComplete="nope"
                        className={`mt-2 p-2 w-full border rounded-md ${formErrors.bairro ? "border-red-500" : ""}`}
                    />
                    {formErrors.bairro && (
                        <p className="text-red-500 text-xs mt-1 mb-2">{formErrors.bairro}</p>
                    )}
                </div>
                <div>
                    <label htmlFor="cidade" className="block text-gray-700">
                        Cidade residencial: <Required />
                    </label>
                    <input
                        type="text"
                        name="cidade"
                        value={formData.cidade}
                        onChange={handleChange}
                        autoComplete="nope"
                        className={`mt-2 p-2 w-full border rounded-md ${formErrors.cidade ? "border-red-500" : ""}`}
                    />
                    {formErrors.cidade && (
                        <p className="text-red-500 text-xs mt-1 mb-2">{formErrors.cidade}</p>
                    )}
                </div>
                <div>
                    <label htmlFor="estado" className="block text-gray-700">
                        Estado (UF) residencial: <Required />
                    </label>
                    <input
                        type="text"
                        name="estado"
                        value={formData.estado}
                        onChange={handleChange}
                        autoComplete="nope"
                        className={`mt-2 p-2 w-full border rounded-md ${formErrors.estado ? "border-red-500" : ""}`}
                    />
                    {formErrors.estado && (
                        <p className="text-red-500 text-xs mt-1 mb-2">{formErrors.estado}</p>
                    )}
                </div>
            </div>
            <hr className="mt-8 mb-8" />
            <Button
                type="button"
                onClick={handleSubmit}
                color="primary"
                className="w-full bg-blue-500 text-white py-2 rounded-md hover:bg-blue-600 transition duration-200"
            >
                {loading && <Loader color={"white"} />}
                Enviar respostas
            </Button>
        </form>
    );
};

export default Form;
